import { render, staticRenderFns } from "./MaterielSkiParticipant.vue?vue&type=template&id=3a4e4c67&scoped=true"
import script from "./MaterielSkiParticipant.vue?vue&type=script&lang=ts"
export * from "./MaterielSkiParticipant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e4c67",
  null
  
)

export default component.exports